import React from 'react';
import { Button } from './Button';
import { globalConfigurableData, partnerMap } from '../../../utils/globalConstant';
import { Platform } from 'react-native';

const variantMap = {
  yes: 'yes',
  no: 'no',
  primary: 'primary',
  secondary: 'secondary',
  outline: 'outline',
  yellow: 'yellow',
  red: 'red',
  black: 'black',
  grey: 'grey',
  'rm-liquidity': 'rm-liquidity',
  'merge-share': 'merge-share',
  'black-bordered': 'black-bordered',
  'black-white': 'black-white',
  'yes-inactive': 'yes-inactive',
  'no-inactive': 'no-inactive',
  // Legacy mappings
  normalBlue: 'primary',
  disable: 'primary',
  btnGrey: 'grey',
  btnBlack: 'black',
  btnBlackInactive: 'black',
  btnBlue: 'primary',
  disableBlack: 'black',
  btnBlackNew: 'black',
  disableBlackNew: 'black',
  blackBorderedButton: 'black-bordered',
  btnBlackWhite: 'black-white',
  yesInactive: 'yes-inactive',
  noInactive: 'no-inactive',
  rmLiquidity: 'rm-liquidity',
  mergeShare: 'merge-share',
};

/**
 * Compatibility wrapper for CustomButton
 */
export const CustomButtonCompat = ({
  type,
  onPress,
  disabled,
  children,
  style,
  textStyle,
  translate,
  isImageInBtn,
  leftIcon,
  rightIcon,
  subText,
  subTextStyle,
  isSmileEvent,
  returnsVar,
  delay,
  ...props
}) => {
  const variant = variantMap[type] || 'primary';
  const className = Platform.OS === 'web' && partnerMap?.isTmr ? 'tmr-button' : undefined;

  return (
    <Button
      variant={variant}
      onPress={onPress}
      disabled={disabled}
      style={style}
      textStyle={textStyle}
      translate={translate}
      isImageInBtn={isImageInBtn}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      subText={subText}
      subTextStyle={subTextStyle}
      isSmileEvent={isSmileEvent}
      returnsVar={returnsVar}
      delay={delay}
      className={className}
      {...props}
    >
      {children}
    </Button>
  );
};

/**
 * Compatibility wrapper for AnimatedButtons
 */
export const AnimatedButtonsCompat = ({
  onPressYes,
  onPressNo,
  disabled,
  style,
  textStyle,
  isSmileEvent,
  returnsVar,
  delay,
  ...props
}) => {
  const className = Platform.OS === 'web' ? 'button-ripple' : undefined;

  return (
    <>
      <Button
        variant="yes"
        onPress={onPressYes}
        disabled={disabled}
        style={style}
        textStyle={textStyle}
        isSmileEvent={isSmileEvent}
        returnsVar={returnsVar?.yes}
        delay={delay}
        className={className}
        {...props}
      >
        Yes
      </Button>
      <Button
        variant="no"
        onPress={onPressNo}
        disabled={disabled}
        style={style}
        textStyle={textStyle}
        isSmileEvent={isSmileEvent}
        returnsVar={returnsVar?.no}
        delay={delay}
        className={className}
        {...props}
      >
        No
      </Button>
    </>
  );
};

/**
 * Compatibility wrapper for PortfolioButton
 */
export const PortfolioButtonCompat = ({
  onPress,
  active,
  children,
  style,
  textStyle,
  ...props
}) => {
  const variant = active ? 'primary' : 'outline';
  const className = Platform.OS === 'web' ? 'button-ripple' : undefined;

  return (
    <Button
      variant={variant}
      onPress={onPress}
      style={[
        {
          minWidth: 100,
          marginHorizontal: 4,
        },
        style,
      ]}
      textStyle={textStyle}
      className={className}
      {...props}
    >
      {children}
    </Button>
  );
}; 